import styled from "@emotion/styled";
import { Link, Tag } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";

/**
 * typeof map of {filter id: filter value}
 */
export interface FiltersValues {
    [index: string]: string[];
}

export interface BubblesProps {
    className?: string;
    values: FiltersValues;
    onChange: (param: string, values: string[]) => void;
    onClearBubbles: () => void;
}

const StyledBubbles = styled("div")(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "baseline",
    gap: theme.spacing(1),
}));

/**
 * Sessions Filter-Bar Bubbles
 */
export function Bubbles(props: BubblesProps) {
    const { className = "", values, onChange, onClearBubbles } = props;

    const handleBubbleClick = (param: string, value: string) => {
        const filterValues = values[param];
        // remove value from current values
        const currentValues = filterValues.filter((val: string) => val !== value);
        onChange(param, currentValues);
    };

    return (
        <StyledBubbles className={`${className} kms-ds-agenda-filter-bar-bubbles`}>
            {Object
                .entries(values)
                .map(([param, values]) =>
                    values.map((value: string) => (
                        <Tag
                            className="kms-ds-agenda-filter-bar-bubble"
                            key={`${param}-${value}`}
                            label={value}
                            onDelete={() => handleBubbleClick(param, value)}
                        />
                    ))
                )}
            <Link component="button" size={"small"} onClick={onClearBubbles}>
                {translate("Clear All")}
            </Link>
        </StyledBubbles>
    );
}

export default Bubbles;
